import _ from 'lodash';
import { useField } from 'formik';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from 'generated/graphql';
import useAuthenticatedUser from 'packages/kakapo-ui-application/hooks/useAuthenticatedUser';
import Color from 'packages/kakapo-ui-kit/components/common/Color';

import DashboardEmployeesSelectorModal from './DashboardEmployeesSelectorModal';

const Link = styled(Box)`
	color: ${(props) => props.theme.colors.primary};
	text-decoration: underline;
	cursor: pointer;
`;

export default function DashboardEmployeesSelector() {
	const { t } = useTranslation();
	const viewer = useAuthenticatedUser();

	const [, , { setValue }] = useField('userIDs');

	const [users, setUsers] = useState<graphql.User[]>([viewer]);
	const [modal, setModal] = useState(false);

	const ids = users.map(({ id }) => id);

	useEffect(() => {
		setValue(ids);
	}, [ids.join(',')]);

	function updateUsers(users: graphql.User[]) {
		if (users.length === 0) {
			setUsers([viewer]);
		} else {
			setUsers(users);
		}
	}

	return (
		<Box>
			{_.sortBy(users, (user) => `${user.firstName} ${user.lastName}`)
				.slice(0, users.length > 5 ? 4 : 5)
				.map((user) => (
					<Box mb={2} key={user.id}>
						<Flex alignItems="center">
							<Box flexGrow={0} flexShrink={0} width={20}>
								<input
									style={{ display: 'block' }}
									type="checkbox"
									checked
									disabled={users.length === 1 && user.id === viewer.id}
									onChange={() => {
										updateUsers(users.filter(({ id }) => id !== user.id));
									}}
								/>
							</Box>
							<Box>
								<Color color="slateBlue">
									{user.firstName} {user.lastName}
								</Color>
							</Box>
						</Flex>
					</Box>
				))}
			{users.length > 5 && (
				<Flex alignItems="center" mb={2}>
					<Box flexGrow={0} flexShrink={0} width={20} />
					<Color color="slateBlue">
						{t('dashboard.sidebar.filters.employees.more', { count: users.length - 4 })}
					</Color>
				</Flex>
			)}
			<Flex alignItems="center">
				<Box flexGrow={0} flexShrink={0} width={20} />
				<Link onClick={() => setModal(true)}>
					{t('dashboard.sidebar.filters.employees.extendSelection')}
				</Link>
			</Flex>
			{modal && (
				<DashboardEmployeesSelectorModal
					selection={users}
					onChange={updateUsers}
					onDismiss={() => setModal(false)}
				/>
			)}
		</Box>
	);
}
